const CustomerLogos = () => {
  const testimonialQuotes = [
    { text: "PhoneticPro saves me hours every week", author: "Sarah K.", role: "Call Center Lead" },
    { text: "Essential for clear radio communication", author: "Capt. Mike R.", role: "Commercial Pilot" },
    { text: "My students love how easy it is to use", author: "Prof. Chen", role: "Language Teacher" },
  ];


  return (
    <section className="py-16 px-6 border-t border-border">
      <div className="max-w-5xl mx-auto">
        {/* Scrolling Testimonials */}
        <div className="mb-12 overflow-hidden">
          <div className="flex animate-scroll gap-8">
            {[...testimonialQuotes, ...testimonialQuotes].map((quote, index) => (
              <div
                key={index}
                className="flex-shrink-0 bg-card border border-border rounded-lg p-4 w-72"
              >
                <p className="text-sm text-muted-foreground mb-2">"{quote.text}"</p>
                <div className="text-xs">
                  <span className="font-medium">{quote.author}</span>
                  <span className="text-muted-foreground"> · {quote.role}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Trusted By Section */}
        <div className="text-center">
          <p className="text-sm text-muted-foreground mb-6">
            Trusted by professionals worldwide
          </p>
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 opacity-60">
            {/* Company/Industry Logos as Text Badges */}
            <div className="flex items-center gap-2 px-4 py-2 bg-muted/50 rounded-full">
              <div className="w-6 h-6 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white text-xs font-bold">A</div>
              <span className="text-sm font-medium">Aviation</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-muted/50 rounded-full">
              <div className="w-6 h-6 rounded-full bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center text-white text-xs font-bold">E</div>
              <span className="text-sm font-medium">Education</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-muted/50 rounded-full">
              <div className="w-6 h-6 rounded-full bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center text-white text-xs font-bold">C</div>
              <span className="text-sm font-medium">Call Centers</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-muted/50 rounded-full">
              <div className="w-6 h-6 rounded-full bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center text-white text-xs font-bold">E</div>
              <span className="text-sm font-medium">Emergency Services</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-muted/50 rounded-full">
              <div className="w-6 h-6 rounded-full bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center text-white text-xs font-bold">M</div>
              <span className="text-sm font-medium">Military</span>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 20s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default CustomerLogos;